import * as React from 'react';
export const chaseSvg = React.forwardRef(function chaseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.391 5.87H10.74V15l4.252-4.267L15 6.45c0-.273-.318-.581-.609-.581ZM9.55 15c.272 0 .58-.327.58-.609V10.74H1L5.275 15H9.55ZM5.87 5.26V1.61c0-.282.337-.609.608-.609h4.261L15 5.26H5.87Zm-.61 4.87H1.61c-.29 0-.609-.337-.609-.608V5.26L5.26 1v9.13Z',
    }),
  );
});
chaseSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chase = {
  category: 'paymentmethod',
  colorable: true,
  name: 'chase',
  svg: chaseSvg,
};
